import { useEffect, useRef, useState } from 'react';
import { ApiCall, FindTranslatedKey, handleDateChange } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { DateBox, FormButton, InputBox, base64ToBlob } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { useDispatch } from 'react-redux';

const PacketBookingReport = () => {
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch([])
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const selectedDate = new Date();
    selectedDate.setDate(selectedDate.getDate() - 14);
    const selectedDate2 = new Date();
    selectedDate2.setDate(selectedDate2.getDate());
    const dateArr = selectedDate.toDateString().split(" ");
    const formattedDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        bookingDateFrom: formattedDate,
        bookingDateTo: formattedDate1,
        cCode: '',
        awbNo: '',
        bookedBy: ''
    });

    const getBookingReportData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Report/ShowBookingReport', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = () => {
        setFormData({
            bookingDateFrom: formattedDate,
            bookingDateTo: formattedDate1,
            cCode: '',
            awbNo: '',
            bookedBy: ''
        });
        getBookingReportData()
        inputrefs.current['txtFromDate'].focus()
    }

    const handleChange1 = (event, value) => {
        getBookingReportData(value);
    };
    const handlePrint = async (value) => {
        await dispatch(setSubLoading(true))
        let imgresult = await ApiCall('/api/Report/AWBNoPrint', { AwbNo: value });
        await dispatch(setSubLoading(false))
        let result = imgresult;
        if (result.status === 'ERROR' || result.status === 'EXPIRED') {
            await NotificationSound(result.status, result.message, result.focus, inputrefs, handleClear);
            await dispatch(setSubLoading(false))
        }
        const blob = base64ToBlob(result.documentPdfBase64?.split(',')[1], 'application/pdf');
        const url = URL.createObjectURL(blob);
        const PDFWindow = window.open("");
        PDFWindow.document.write("<iframe width='100%' height='100%' src='" + url + "'></iframe>");
    }
    useEffect(() => {
        getBookingReportData()
    }, [sortConfig])

    useEffect(() => {
        
        document.title = 'Booking Report'
        inputrefs.current['txtFromDate'].focus()
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Booking Report')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date From"
                                placeholder="Booking Date From"
                                id='txtFromDate'
                               // value={formData.bookingDateFrom ? formData.bookingDateFrom : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtToDate'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.bookingDateFrom === '' ? '' : new Date(formData.bookingDateFrom)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDateFrom')}
                            />
                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date To"
                                placeholder="Booking Date To"
                                id='txtToDate'
                               // value={formData.bookingDateTo ? formData.bookingDateTo : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAWBBill'].focus()
                                    };
                                }}
                                required={false}
                                selected={formData.bookingDateTo === '' ? '' : new Date(formData.bookingDateTo)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDateTo')}
                            />
                           
                            <InputBox
                                id="txtAWBBill"
                                PlaceHolderText="AWB No."
                                autoComplete="off"
                                maxLength='25'
                                required={false}
                                label='AWB No.'
                                value={formData.awbNo}
                                onChange={(e) => {
                                    //let { value } = e.target
                                    //const aphanum = value.replace(/[^a-zA-Z0-9]/g, '')
                                    setFormData({ ...formData, awbNo: e.target.value })
                                }}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                            />
                           
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            Search={true}
                            save={false}
                            inputrefs={inputrefs}
                            handleSubmit={getBookingReportData}
                            handleExport={() => handleDownloadExcel(`/api/Report/ShowBookingReport`, formData, 'Booking Report')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                PageName={'PickUpReport'}
                loading={isLoading}
                Filter={false}
                tableData={tableData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                handlePrint={handlePrint}
            />
        </>
    )
}
export default PacketBookingReport;